import { exeRequest } from '../utils/APIUtils'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    getPartenairesRecent: async (params = {}) => exeRequest(`/admin//dashboard/partenaires/recent${buildQuery(params)}`, "GET"),
    getPartenaireInscriptionParJour: async (params = {}) => exeRequest(`/admin/dashboard/partenaires/inscriptions-per-day${buildQuery(params)}`, "GET"),
    getPartenaireYandex: async (params = {}) => exeRequest(`/admin/dashboard/yandex/partenaires${buildQuery(params)}`, "GET"),
    getPartenairesThisWeekWithVehicle: async (params = {}) => exeRequest(`/admin/dashboard/partenaires/this-week/with-vehicle${buildQuery(params)}`, "GET"),
    getPartenairesThisWeekWithoutVehicle: async (params = {}) => exeRequest(`/admin/dashboard/partenaires/this-week/without-vehicle${buildQuery(params)}`, "GET"),
    getOperationStats: async (params = {}) => exeRequest(`/admin/dashboard/operations/stats${buildQuery(params)}`, "GET"),
    getYandexVsTigoon: async (params = {}) => exeRequest(`/admin/dashboard/sync/yandex-vs-tigoon${buildQuery(params)}`, "GET"),
    getOperationsStats: async (params = {}) => {
      const { cityCode, from, to, detail } = params;
      const qs = { ...(cityCode ? { cityCode } : {}), ...(from ? { from } : {}), ...(to ? { to } : {}), ...(detail ? { detail: true } : {}) };
      return exeRequest(`/admin/dashboard/operations/stats${buildQuery(qs)}`, 'GET');
    },
    listAllOperations: async (params = {}) => exeRequest(`/admin/dashboard/operations/list${buildQuery(params)}`, "GET"),
}

// petit helper pour sérialiser les params
function buildQuery(params) {
  const q = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
  return q ? `?${q}` : '';
}
